import { useIsOciProduct } from "./useIsOciProduct";
import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// 사이트 URL필드 표시 여부
export const useShowSiteUrl = () => {
  const { isOciProduct } = useIsOciProduct();
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);

  if (isOciProduct) {
    // OCI는 WRAPSODY, FIRESIDE 제외하고 사이트 URL 표시
    return !["WRAPSODY", "FIRESIDE"].includes(productKey as string);
  } else {
    // Fireside, Mind Sat은 사이트 URL입력 X -> 사이트 ID로 처리
    if (["FIRESIDE", "MIND_SAT"].includes(productKey as string)) return false;
    // OCI가 아닌 경우
    return true;
  }
};
